<template>
  <vue-final-modal v-bind="$attrs" classes="modal-container" content-class="modal-content">
    <h2 class="font-bold mb-6">Secure form submitted.</h2>
    <div class="mb-10">
      <p>The CHESS Connections Text team has received your referral; one of our peers will be messaging the individual shortly to initiate support.</p>
    </div>
    <button @click="closeModal">Close</button>
  </vue-final-modal>
</template>

<script>
export default {
  name: 'SuccessModal',
  data() { // component props
    return {}
  },
  created() { /* Called synchronously after the instance is created */ },
  mounted() { /* Called after the instance has been mounted */ },
  methods: { // component functions
    closeModal() {
      this.$vfm.hideAll();
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  h2 {
    color: #022169;
    font-weight: 500;
    font-size: 36px;
    line-height: 64px;
    letter-spacing: -0.05em;
  }
  p {
    font-weight: 400;
    font-size: 16px;
    line-height: 32px;
    letter-spacing: -0.03em;
    color: #5B5C90;
  }
  button {
    background: #022169;
    color: #fff;
    border-radius: 8px;
    padding: 16px 24px;
    min-width: 150px;
    font-size: 18px;
    font-weight: 500;
    line-height: 24px;
    letter-spacing: -0.05em;
    transition: all .3s;
  }
    button:hover {
     opacity: 0.85; 
    }
  @media(max-width: 768px) {
    h2 {
      font-size: 24px;
      line-height: 42px;
    }
    button {
      width: 100%;
      max-width: 400px;
      text-align: center;
    }
  }
</style>

<!-- Not "scoped" to style modal -->
<style>
  .modal-container {
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .vfm--overlay {
    background: rgba(8, 17, 53, 0.38) !important;
  }
  .modal-content {
    text-align: center;
    border-radius: 16px !important;
    background: #ffffff;
    padding: 20px 20px 40px;
    margin: 16px;
    width: 600px;
    top: auto !important;
    left: auto !important;
  }
</style>
